<template>
    <v-card :loading="loading">
        <v-form>
            <v-container>
                <fieldset>
                    <v-row>
                        <v-col cols="12">
                            <non-form-field-errors :errors="errors"></non-form-field-errors>
                        </v-col>
                        <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">Discount</label>
                            <v-text-field type="number" :error-messages="errors.amount" v-model="data.amount"
                                          label="Discount" placeholder="Discount"
                                          solo></v-text-field>
                        </v-col>

                        <v-col cols="12" sm="6" md="6">
                            <label class="custom-label">Code</label>
                            <v-text-field
                                    v-model="data.code"
                                    :error-messages="errors.code"
                                    label="Discount Code"
                                    placeholder="Discount Code"
                                    solo
                            ></v-text-field>
                        </v-col>
                        <v-col cols="12">
                            <v-checkbox :error-messages="errors.is_percent" label="Is Percent"
                                        v-model="data.is_percent"></v-checkbox>
                        </v-col>
                        <v-col cols="12">
                            <label class="custom-label">Description</label>
                            <v-textarea :error-messages="errors.description" v-model="data.description" solo
                                        name="input-7-4" label="Discount Description"
                                        placeholder="Discount Description"></v-textarea>
                        </v-col>

                        <v-col cols="12">
                            <v-btn color="primary" @click="save" :loading="loading" dark>Save</v-btn>
                        </v-col>
                    </v-row>
                </fieldset>
            </v-container>
        </v-form>
    </v-card>
</template>

<script>
    import NonFormFieldErrors from "../utils/errors/NonFormFieldErrors";
    import Form from "../../utils/form";

    export default {
        name: "AddDiscount",
        components: {NonFormFieldErrors},
        props: {
            id: {
                type: Number,
                default: null,
            }
        },
        data() {
            return {
                loading: true,
                data: {
                    amount: "",
                    description: "",
                    is_percent: true,
                    code: ""
                },
                errors: {},
            };
        },
        methods: {
            save(){
                if(this.id){
                    this.update()
                }else{
                    this.create()
                }

            },
            create() {
                this.loading = true
                let form = new Form({
                    ...this.data
                })
                form.post(apiRoutes.discounts.url).then(response => {
                    this.loading = false
                    this.errors = {}
                    this.$router.replace({name: "Discounts"})
                }).catch(response => {
                    if (response.status === 400) {
                        this.errors = response.data
                    }
                    this.loading = false
                })
            },
            update() {
                this.loading = true
                let form = new Form({
                    ...this.data
                })
                form.put(apiRoutes.discounts.url+this.id+"/").then(response => {
                    this.loading = false
                    this.errors = {}
                    this.$router.replace({name: "Discounts"})
                }).catch(response => {
                    if (response.status === 400) {
                        this.errors = response.data
                    }
                    this.loading = false
                })
            }
        },
        mounted() {
            this.loading = false
            if (this.id) {
                this.loading = true
                axios.get(apiRoutes.discounts.url + this.id).then(response => {
                    this.data = {
                        amount: response.data.amount,
                        code: response.data.code,
                        is_percent: response.data.is_percent,
                        description: response.data.description
                    }
                    this.loading = false
                })
            }
        }
    };
</script>

<style lang="scss" scoped>
    fieldset {
        border: 0;

        &:not(:last-of-type) {
            border-bottom: 1px dashed #8898aa80;
            margin-bottom: 20px;
        }

        & legend {
            font: Bold 20px/25px Lato;
            color: #172b4d;
        }

        & label {
            font: Bold 15px/40px Lato;
            color: #172b4d;
        }
    }
</style>